import { MenuItem, TextField } from '@mui/material';
import {
  SERP_MAP_STYLES,
  SERP_MAP_STYLE_LABELS,
  SERP_MAP_STYLE_DESCRIPTIONS,
  type SerpMapStyle,
} from '../../../api/src/fakes/serp-appearance';

export function SerpMapStyleSelect({
  value,
  disabled,
  compact = false,
  onChange,
}: {
  value: SerpMapStyle;
  disabled?: boolean;
  compact?: boolean;
  onChange(style: SerpMapStyle): void;
}) {
  return (
    <TextField
      select
      label="Оформление плиток"
      value={value}
      disabled={disabled}
      helperText={compact ? undefined : SERP_MAP_STYLE_DESCRIPTIONS[value]}
      onChange={(e) => onChange(e.target.value as SerpMapStyle)}
      sx={{ minWidth: 225, width: compact ? 225 : undefined, maxWidth: '100%' }}
    >
      {SERP_MAP_STYLES.map((style) => (
        <MenuItem key={style} value={style}>
          {SERP_MAP_STYLE_LABELS[style]}
        </MenuItem>
      ))}
    </TextField>
  );
}
